import { PriceQuoteResponse } from 'store/widget/widget.types';

export interface CardUiState {
  showCards: boolean;
  showAddCard: boolean;
  showHoldNotice: boolean;
}

export function getCardUiState(quote: Pick<PriceQuoteResponse, 'priceCents'> | undefined): CardUiState {
  const isFree = quote?.priceCents === 0;

  return {
    showCards: !isFree,
    showAddCard: !isFree,
    showHoldNotice: quote !== undefined && quote.priceCents > 0,
  };
}
